<section class="content">
  <div class="card" style="padding:25px">

  <div class="container-fluid">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div *ngIf="dataSource == null">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value"
        style="margin-left: 44%;margin-top: 16%;">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="dataSource != null">
      <div class="col" *ngIf="!boothService.is_display_booth_register_component">
        <button mat-fab color="primary" (click)="registerBooth()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <!-- <div class="card" style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px;font-size: 15px; margin-top: 18px;border-radius: 5px;">
          <table class="table table-hovered">
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Code</th>
              <th>Zone</th>
              <th>Business Type</th>
              <th>Pincode</th>
              <th>Working From</th>
              <th>Working TO</th>
              <th>Edit</th>
            </tr>
            <tr *ngFor="let element of dataSource; let i = index">
              <td> {{i+1}}</td>
              <td> {{element.name}}</td>
              <td> {{element.code}}</td>
              <td> {{element.zone}}</td>
              <td> {{element.business_type}}</td>
              <td> {{element.pincode}}</td>
              <td> {{element.working_hours_from}}</td>
              <td> {{element.working_hours_to}}</td>
              <td (click)="editBooth(element)">
                <mat-icon>edit</mat-icon>
              </td>
            </tr>
          </table>
        </div> -->
        <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="mat-elevation-z8">
          <div matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Sl.No.</th>
            <td mat-cell *matCellDef="let element; let i = index"> {{i+1}}</td>
          </div>

          <!-- <div matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name
              <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                <mat-label>Search by name</mat-label>
                <input matInput [formControl]="nameFilter">
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.name}}
                </div>
              </div>
            </td>
          </div> -->

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              style="background: #97cdef;height: 110px; top: 0px; position: sticky; z-index: 100;"> Name
              <div class="form-group" style="position: absolute; padding-top: 37px;">
                <input type="text" [formControl]="nameFilter" class="form-control" placeholder="search"
                  style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
          </ng-container>

          <!-- <div matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background-color: cadetblue; height: 110px; top: 0px; position: sticky; z-index: 100;">Code
              <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                <mat-label>Search by code</mat-label>
                <input matInput [formControl]="codeFilter" style="border: 1px solid lightgray; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.code}}
                </div>
              </div>

            </td>
          </div> -->

          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              style="background: #97cdef;height: 110px; top: 0px; position: sticky; z-index: 100;"> Code
              <div class="form-group" style="position: absolute; padding-top: 37px;">
                <input type="text" [formControl]="codeFilter" class="form-control" placeholder="search"
                  style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.code}}</td>
          </ng-container>

          <!-- <div matColumnDef="business_type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Business Type</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.business_type}}
                </div>
              </div>
            </td>
          </div> -->
          <ng-container matColumnDef="business_type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              style="background: #97cdef;height: 110px; top: 0px; position: sticky; z-index: 100;"> Business Type
              <div class="form-group" style="position: absolute; padding-top: 37px;">
                <input type="text" [formControl]="businessTypeFilter" class="form-control" placeholder="search"
                  style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.business_type}}</td>
          </ng-container>

          <!-- <div matColumnDef="pincode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Pincode</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.pincode}}
                </div>
              </div>
            </td>
          </div> -->

          <ng-container matColumnDef="pincode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              style="background: #97cdef;height: 110px; top: 0px; position: sticky; z-index: 100;"> Pincode
              <div class="form-group" style="position: absolute; padding-top: 37px;">
                <input type="number" [formControl]="pincodeFilter" class="form-control" placeholder="search"
                  style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.pincode}}</td>
          </ng-container>

          <!-- <div matColumnDef="zone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Zone</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.zone}}
                </div>
              </div>
            </td>
          </div> -->

          <ng-container matColumnDef="zone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              style="background: #97cdef;height: 110px; top: 0px; position: sticky; z-index: 100;"> Zone
              <div class="form-group" style="position: absolute; padding-top: 37px;">
                <input type="text" [formControl]="zoneFilter" class="form-control" placeholder="search"
                  style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.zone}}</td>
          </ng-container>

          <div matColumnDef="mor_route">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Mor Route
              <div class="form-group" style="position: absolute; padding-top: 37px;">
                <input type="text" [formControl]="mor_filter" class="form-control" placeholder="search"
                  style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.mor_route | slice: 0: -4}}
                </div>

              </div>

            </td>
          </div>

          <div matColumnDef="eve_route">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Eve Route
              <div class="form-group" style="position: absolute; padding-top: 37px;">
                <input type="text" [formControl]="eve_filter" class="form-control" placeholder="search"
                  style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.eve_route | slice: 0: -4}}
                </div>
                <div class="col">
                  <mat-icon (click)="editBooth(element)">edit</mat-icon>
                </div>
              </div>

            </td>
          </div>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator> -->
      </div>

      <div class="col-9" *ngIf="boothService.is_display_booth_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideBoothRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-booth-register></app-booth-register>
      </div>
    </div>
  </div>
  </div>
</section>
